<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="门店名：" label-width="100">
        <el-input
          v-model="searchForm.name"
          placeholder="门店名"
          clearable
          @keyup.enter.native="getCommunity"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getCommunity" type="success">搜索</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="update(null)"> 添加门店 </el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="图片" align="center" prop="cover">
        <template slot-scope="scope">
          <img width="50px" height="50px" :src="scope.row.cover" alt="" />
        </template>
      </el-table-column>
      <el-table-column
        label="门店"
        align="center"
        prop="name"
      ></el-table-column>
      <el-table-column label="地址" align="center" prop="address">
      </el-table-column>
      <el-table-column
        label="联系方式"
        align="center"
        prop="phone"
      ></el-table-column>
      <el-table-column label="营业时间" align="center" prop="businessTime">
      </el-table-column>
      <el-table-column
        label="简介"
        align="center"
        prop="introduction"
      ></el-table-column>

      <el-table-column
        prop="icon"
        align="center"
        width="360"
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain @click="update(scope.row.id)">
            编辑
          </el-button>

          <el-button
            type="danger"
            plain
            slot="reference"
            @click="delHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    ></el-pagination>
    <updata ref="updata" v-if="updata" @refreshDataList="getCommunity" />
  </div>
</template>

<script>
import updata from "./updata";

export default {
  name: "park",
  components: {
    updata,
  },
  data() {
    return {
      searchForm: {
        name: "",
      },
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      total: 0,
      size: 10,
      current: 1,
      updata: false,
      gardenWorker: false,
      gardenGoods: false,
    };
  },
  created() {
    this.getCommunity();
  },
  methods: {
    update(id) {
      this.updata = true;
      this.$nextTick(() => {
        this.$refs.updata.init(id);
      });
    },
    gardenWorkerList(id) {
      this.gardenWorker = true;
      this.$nextTick(() => {
        this.$refs.gardenWorker.init(id);
      });
    },
    gardenGoodsList(id) {
      this.gardenGoods = true;
      this.$nextTick(() => {
        this.$refs.gardenGoods.init(id);
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getCommunity();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getCommunity();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
      console.log(this.multipleSelection);
    },
    //获取列表
    getCommunity() {
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/store/getStoreList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.total;
        });
    },
    //删除
    delHandle(id) {
      this.$confirm("确定要删除这条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/store/deleteStore", {
            id: id,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，删除成功",
              type: "success",
              onClose: () => {
                this.getCommunity();
              },
            });
          });
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
